import * as React from 'react'

interface MdErrorsProps {
  errors: any[]
}

export default function MdErrors(props: any) {
  return (
    <div style={props.style}>
      <div className="results">
        <div className="inline-status">
          {props.errors.map((error, key) => {
            return (
              <span key={key}> {error.detail}</span>
            )
          })}
        </div>
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./react/components/widgets/MdErrors.tsx